import React, { useEffect, useState } from "react";
import "./CompanyRiskScoreInput.scss";
import { withTranslation } from "react-i18next";
import RiskInputService from "../../../core/service/RiskInputService";
import Utils from "../../../core/utilities/Utils";
import { startYear, currentYear } from "../../../core/constants/common";
import RiskConfigService from "../../../core/service/RiskConfigService";
import { Table, OverlayTrigger } from "react-bootstrap";
import { BiGitMerge, BiPencil } from "react-icons/bi";
import { toast } from "react-toastify";
import nodataimg from "../../../images/nodatafound.png";
import { FcFinePrint } from "react-icons/fc";

import { BsXSquare } from "react-icons/bs";
const CompanyRiskScoreInput = ({ t, regId, configType }) => {
  var lsDat = JSON.parse(localStorage.getItem("authority"));
  const companyId = lsDat.profile.company.id;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [regulations, setRegulations] = useState([]);
  const [regulation, setRegulation] = useState([]);
  const [regulationId, setRegulationId] = useState(regId);
  const [frequency, setFrequency] = useState("");

  const [riskscorelist, setRiskScoreList] = useState([]);
  const [riskscoreparent, setRiskScoreParent] = useState(null);
  const [riskscoresub, setRiskScoreSub] = useState(null);
  const [issubpage, setIsSubPage] = useState(false);

  const [encoded, setEncoded] = useState(null);
  const [frequencyparam, setFrequencyParam] = useState(null);
  const [supplierid, setSupplierId] = useState(null);

  const [iseditable, setIsEditable] = useState(false);
  const [weightedmaxscore, setWeightedMaxScore] = useState(null);
  const [weightedscore, setWeightedScore] = useState(null);
  const [overallscore, setOverallScore] = useState(null);
  const [regulationdetails, setRegulationDetails] = useState(null);
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [frequencymonth, setFrequencyMonth] = useState("");
  let supplierId = 4;
  useEffect(() => {
    setRiskScoreList([]);
    setRegulationId(regId);
    RiskConfigService.getRegulationDetails(regId, configType)
      .then((response) => {
        setRegulation(response?.data);
        let data = response?.data;
        const month = Utils.getMonthFromFrequency(data?.frequency);
        setFrequencyMonth(month);
        setFrequency(data?.frequency);
        if (
          data?.id !== "" &&
          data?.id != null &&
          data?.frequency !== "" &&
          data?.frequency != null
        ) {
          switch (data?.frequency) {
            case "ANNUAL":
            case "QUARTERLY":
            case "HALF_YEARLY":
              setFrequencyMonth("01");
              break;
            case "FINANCIAL_YEAR":
              setFrequencyMonth("04");
              break;
            default:
              break;
          }
          getCompanyRisk(data?.id, data?.frequency, annualyear, month);
        }
      })
      .catch((error) => {
        console.log("err", error);
      });
  }, [regulation?.id, configType, regId]);
  /** Fetch company risk parameters */
  const getCompanyRisk = (
    regulationIdDat,
    frequencyDat,
    annualYearDat,
    freqMonth,
    paramid = null
  ) => {
    var frequencyParam = null;
    frequencyParam = annualYearDat + "-" + freqMonth + "-01";
    setFrequencyParam(frequencyParam);
    RiskInputService.getCompanyData(companyId, regulationId, frequencyParam, configType, paramid)
      .then((response) => {
        setIsEditable(false);
        setRegulationDetails(response?.data?.regulation);
        setRiskScoreList([...(response?.data?.riskParamData ?? [])]);
        setWeightedMaxScore(response?.data?.weightedMaxScore);
        setWeightedScore(response?.data?.weightedScore);
        var overallScoreData = null;
        if (
          response?.data?.weightedScore != null &&
          response?.data?.weightedMaxScore != null
        ) {
          overallScoreData = (
            response?.data?.weightedScore / response?.data?.weightedMaxScore
          ).toFixed(2);
        }
        setOverallScore(overallScoreData);
        if (response?.data?.parentRiskParam != null) {
          setIsSubPage(true);
          if (response?.data?.parentRiskParam?.parent !== undefined) {
            setRiskScoreParent(response?.data?.parentRiskParam?.parent?.id);
          } else {
            setRiskScoreParent(null);
          }
        } else {
          setIsSubPage(false);
          setRiskScoreParent(null);
        }
      })
      .catch((error) => {
        setRiskScoreList([]);
        console.log("err", error);
      });
  };

  const updateFieldChanged = (index) => (e) => {
    const newArr = riskscorelist.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setRiskScoreList(newArr);
  };
  const handleSearch = (query) => {
    setIsLoading(true);
    RiskInputService.getSupplier(companyId, query)
      .then((response) => {
        const options = response?.data?.map((i) => ({
          id: i?.companyId,
          legalName: i?.legalName,
        }));
        setOptions(options);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
      });
  };
  const submitDataPoint = async (e) => {
    var objBody = {
      dataPoints: [],
    };
    for (let i = 0; i < riskscorelist.length; i++) {
      var body = {
        id: riskscorelist[i].id,
        riskParamId: riskscorelist[i].riskParam?.id,
        score: riskscorelist[i].score,
      };
      objBody.dataPoints.push(body);
    }

    RiskInputService.saveCompanyDataPoint(
      companyId,
      regulationId,
      frequencyparam,
      objBody
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsEditable(false);
          getCompanyRisk(regulationId, frequency, annualyear, frequencymonth);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const subBranchRisk = (dat) => {
    if (dat.childrenCount > 0) {
      setRiskScoreSub(dat.id);
      getCompanyRisk(regulationId, frequency, annualyear, frequencymonth, dat.id);
    }
  };

  const goPreviousBranch = (dat) => {
    setRiskScoreSub(riskscoreparent);
    getCompanyRisk(regulationId, frequency, annualyear, frequencymonth);
  };

  const riskCategory = (val) => {
    if (val) {
      for (let i = 0; i < regulationdetails.resultConfigs.length; i++) {
        let iterate = regulationdetails.resultConfigs[i];
        if (val >= iterate.minScore && val <= iterate.maxScore) {
          return (
            <p style={{ color: iterate.colorCode }}>{iterate.resultType}</p>
          );
        }
        if (i === regulationdetails.resultConfigs.length - 1) {
          return <div></div>;
        }
      }
    }
  };

  const renderSwitch = () => {
    const options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    switch (frequency) {
      case "ANNUAL":
        return (
          <div>
            {" "}
            <select
              className="form-select"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                getCompanyRisk(
                  regulationId,
                  frequency,
                  e.target.value,
                  frequencymonth
                );
              }}
              value={annualyear}
            >
              {options}
            </select>
          </div>
        );
      case "FINANCIAL_YEAR":
        options.length = 0;
        for (let i = currentYear; i >= startYear; i--) {
          options.push(
            <option value={i} key={i}>
              {i}(APRIL)
            </option>
          );
        }
        return (
          <div className="col-md-12">
            <select
              className="form-select col-md-6"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                setFrequencyMonth("04");
                getCompanyRisk(regulationId, frequency, e.target.value, "04");
              }}
              value={annualyear}
            >
              {options}
            </select>
          </div>
        );
      case "QUARTERLY":
        return (
          <div className="col-md-12">
            <select
              className="form-select col-md-6"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
              }}
              value={annualyear}
            >
              {options}
            </select>

            <select
              className="form-select col-md-6"
              required
              onChange={(e) => {
                setFrequencyMonth(e.target.value);
                getCompanyRisk(
                  regulationId,
                  frequency,
                  annualyear,
                  e.target.value
                );
              }}
              value={frequencymonth}
            >
              {/* <option value="">{t("Select.label")}</option> */}
              <option value="01">Q1</option>
              <option value="04">Q2</option>
              <option value="07">Q3</option>
              <option value="10">Q4</option>
            </select>
          </div>
        );
      case "HALF_YEARLY":
        return (
          <div className="col-md-12">
            <select
              className="form-select col-md-6"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
              }}
              value={annualyear}
            >
              {options}
            </select>

            <select
              className="form-select col-md-6"
              required
              onChange={(e) => {
                setFrequencyMonth(e.target.value);
                getCompanyRisk(
                  regulationId,
                  frequency,
                  annualyear,
                  e.target.value
                );
              }}
              value={frequencymonth}
            >
              <option value="01">JAN-JUN</option>
              <option value="07">JUL-DEC</option>
            </select>
          </div>
        );
      default:
        return "";
    }
  };
  return (
    <div className="RiskScoreInput">
      <div className="row m-0">
        <div className="col-lg-4  p-2">
          <label className="mb-1">
            {t("ReportingPeriod.label")} <span className="text-red">*</span>
          </label>
          {renderSwitch()}
        </div>
      </div>

      <div className="List_Table_01 p-2">
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                <th>{t("RiskParameter.label")}</th>
                <th></th>
                <th className="text-center">{t("MaxScore.label")}</th>
                <th className="text-center">
                  <span className="me-2">{t("RiskScore.label")}</span>
                  {riskscorelist &&
                    riskscorelist !== undefined &&
                    riskscorelist.length > 0 && (
                      <span>
                        {!iseditable ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(
                              t("EditRiskScore.label")
                            )}
                          >
                            <span>
                              <BiPencil
                                className="cursor"
                                onClick={() => setIsEditable(!iseditable)}
                              />
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(t("CancelEdit.label"))}
                          >
                            <span>
                              <BsXSquare
                                className="cursor"
                                onClick={() => setIsEditable(!iseditable)}
                              ></BsXSquare>{" "}
                            </span>
                          </OverlayTrigger>
                        )}
                      </span>
                    )}
                </th>
                <th className="text-center">{t("RiskScoreIn.label")}</th>
                <th className="text-center">{t("Weightage.label")}</th>
                <th className="text-center">{t("WeightageScore.label")}</th>
              </tr>
            </thead>
            {(riskscorelist === undefined ||
              riskscorelist == null ||
              riskscorelist.length === 0) && (
                <tbody>
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            {riskscorelist &&
              riskscorelist !== undefined &&
              riskscorelist?.length > 0 && (
                <tbody>
                  {riskscorelist?.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.riskParam?.name}</td>
                      <td>
                        {item?.riskParam?.childrenCount > 0 ? (
                          <ul className="cursor list-unstyled d-flex align-middle m-0">
                            <li className="px-1">
                              <h6 className="mb-0">
                                {item?.riskParam?.childrenCount}
                              </h6>
                            </li>
                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("ViewBranch.label")
                              )}
                            >
                              <li
                                className="px-1"
                                onClick={() => subBranchRisk(item?.riskParam)}
                              >
                                <BiGitMerge />
                              </li>
                            </OverlayTrigger>
                          </ul>
                        ) : (
                          <span></span>
                        )}
                      </td>
                      <td className="text-center">
                        {item?.riskParam?.maxScore}
                      </td>
                      <td className="text-center">
                        <div>
                          {iseditable && item?.riskParam?.childrenCount <= 0 ? (
                            <input
                              value={item?.score}
                              name="score"
                              onChange={updateFieldChanged(index)}
                            />
                          ) : (
                            <span>{item?.score}</span>
                          )}
                        </div>
                      </td>
                      <td className="text-center">{item?.weightedAvgScore}</td>
                      <td className="text-center">
                        {item?.riskParam?.weightage} %
                      </td>
                      <td className="text-center">{item?.weightedScore}</td>
                    </tr>
                  ))}
                  <tr>
                    <td className="text-center" colSpan="4">
                      <div className="save-risk-btn">
                        {issubpage && (
                          <button
                            type="button"
                            onClick={() => {
                              goPreviousBranch();
                            }}
                            className="btn btn-secondary px-4"
                          >
                            {t("Back.label")}
                          </button>
                        )}
                        {iseditable && (
                          <button
                            type="button"
                            onClick={() => {
                              submitDataPoint();
                            }}
                            className="btn btn-primary ms-2 px-4 sbmBtn"
                          >
                            {t("Save.label")}
                          </button>
                        )}
                      </div>
                    </td>
                    <td></td>
                    <td className="text-center">
                      {weightedscore && (
                        <div className="Overall_ScoreBox">
                          <h6 className="m-0">{t("OverAllScore.label")}</h6>
                        </div>
                      )}
                    </td>
                    <td className="text-center">
                      {weightedscore && (
                        <div className="p-2 Overall_ScoreBox_View">
                          <h6 className="m-0 text-primary">{weightedscore}</h6>
                          {riskCategory(weightedscore)}
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              )}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(CompanyRiskScoreInput);
